export default "__VITE_ASSET__CQkWbPq6__"